import { Directive, ElementRef, Input } from '@angular/core';
import { take } from 'rxjs';
import { SocialAuthService } from '../socialauth.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'login-google-button',
})
export class GoogleButtonDirective {
  @Input() width: string = '';
  @Input() locale: string = '';
  @Input() customButtonText: string = '';

  constructor(el: ElementRef, socialAuthService: SocialAuthService) {
    const createFakeGoogleWrapper = (locale) => {
      const googleLoginWrapper = document.createElement('div');
      googleLoginWrapper.style.display = 'none';
      googleLoginWrapper.classList.add('custom-google-button');

      document.body.appendChild(googleLoginWrapper);
      google.accounts.id.renderButton(googleLoginWrapper, {
        type: 'icon',
        width: '200',
        locale: locale,
      });

      const googleLoginWrapperButton = googleLoginWrapper.querySelector('div[role=button]') as HTMLDivElement;
      return {
        click: () => {
          googleLoginWrapperButton.click();
        },
      };
    };

    socialAuthService.initState.pipe(take(1)).subscribe(() => {
      Promise.resolve(this.width).then((value) => {
        if (value > '400' || (value < '200' && value != '')) {
          Promise.reject('Please note .. max-width 400 , min-width 200 ' + '(https://developers.google.com/identity/gsi/web/tools/configurator)');
        } else {
          const googleButtonWrapper = createFakeGoogleWrapper(this.locale);
          window['handleGoogleLogin'] = () => {
            googleButtonWrapper.click();
          };

          const div = document.createElement('div');
          div.setAttribute('class', 'sm-login-btn google');
          div.setAttribute('onclick', 'handleGoogleLogin()');

          const icon = document.createElement('i');
          icon.setAttribute('class', 'fab fa-google');
          div.appendChild(icon);

          const text = document.createElement('span');
          text.textContent = this.customButtonText ?? 'Google';
          div.appendChild(text);

          el.nativeElement.appendChild(div);
        }
      });
    });
  }
}
